<template>
  <AdminDepartments></AdminDepartments>
</template>
  

<style src="./admindepartments.css" scoped></style>
<script src="./admindepartments.view.js"></script>

 